import { Component, Input, OnInit } from '@angular/core';
import { CancelPoliciesInformationComponent } from '../../cancel-policies-information/cancel-policies-information.component';
import { MbIconTextModule, MbIconModule } from '@am/moebius';
import { NgIf, NgSwitch, NgSwitchCase, NgClass, UpperCasePipe } from '@angular/common';

@Component({
    selector: 'meal-plan',
    templateUrl: './meal-plan.component.html',
    styleUrls: ['./meal-plan.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        MbIconTextModule,
        MbIconModule,
        NgSwitch,
        NgSwitchCase,
        CancelPoliciesInformationComponent,
        NgClass,
        UpperCasePipe,
    ],
})
export class MealPlanComponent implements OnInit {
  @Input() set beds(beds: any) {
    this.bedsInput = beds;
  }

  @Input() set rate(rate: any) {
    this.rateInput = rate;
  }

  @Input()
  isMobile = false;

  bedsInput: any;
  rateInput: any;
  constructor() {}

  ngOnInit() {}
}
